export function idNameToOptions(s) {
    return s.map((status) => ({
        label: status.name,
        value: status.id
    }));
}
export function idValueToOptions(s) {
    return s.map((status) => ({
        label: status.value,
        value: status.id
    }));
}
